// extracted by mini-css-extract-plugin
module.exports = {"upload":"upload--uugmm"};